import React from "react";
import { Button, ButtonProps } from "antd";
import classNames from "classnames";

type GeneralButtonProps = {
  variant?: "primary" | "default" | "dashed" | "link" | "text";
  customDisabledClassName?: string;
} & ButtonProps;

const GeneralButton: React.FC<GeneralButtonProps> = ({
  children,
  variant = "default",
  className = "",
  disabled = false,
  customDisabledClassName = "",
  ...rest
}) => {
  const finalClassName = classNames(
    className,
    disabled && customDisabledClassName
  );

  return (
    <Button
      type={variant}
      disabled={disabled}
      className={finalClassName}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default GeneralButton;
